// extracted by mini-css-extract-plugin
module.exports = {"twoStepTableRow":"ReportHealthInsuranceBonusTableRow__twoStepTableRow--29Wfo","moneyTd":"ReportHealthInsuranceBonusTableRow__moneyTd--3ZNc1"};